import { useCallback } from "react";
import { ListChecks } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import withRoleCheck from "components/hocs/withRoleCheck";
import RevenueOpportunityStatusPresetService from "services/RevenueOpportunityStatusPreset";
import {
  invalidateRevenueOpportunityStatusPresetsTableQuery,
  useRevenueOpportunityStatusPresetsTable,
} from "hooks/useRevenueOpportunityStatusPresetsTable";
import RevenueOpportunityStatusPresetModal from "routes/revenue_opportunity_status_presets/components/RevenueOpportunityStatusPresetModal";

export const REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS = {
  tableName: "revenue_opportunity_status_presets",
  queryKey: "revenue_opportunity_status_preset",
  className: "RevenueOpportunityStatusPreset",
  header: "Revenue Opportunity Presets",
  headerIcon: ListChecks,
};

const NewRevenueOpportunityStatusPresetModal = withRoleCheck(
  RevenueOpportunityStatusPresetModal,
  [
    ACL_RELATIONSHIPS.revenueOpportunityStatusPreset.create,
    ACL_RELATIONSHIPS.revenueOpportunityStatus.read,
  ]
);

const RevenueOpportunityStatusPresetsTableV3 = () => {
  const { filters, columns } = useRevenueOpportunityStatusPresetsTable({
    tableName: REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.tableName,
  });

  const fetchPresets = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await RevenueOpportunityStatusPresetService.getRevenueOpportunityStatusPresetsAsTable(
            nextQueryParams
          );

        return response;
      } catch (error) {
        console.error(
          "Error fetching revenue opportunity status presets:",
          error
        );
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.headerIcon}
      header={REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.header}
      tableName={REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.tableName}
      queryKey={REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.queryKey}
      className={REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.className}
      fetchData={fetchPresets}
      createButton={
        <NewRevenueOpportunityStatusPresetModal
          onSuccess={invalidateRevenueOpportunityStatusPresetsTableQuery}
        />
      }
      enableSearch
      enableSettings
      invalidateData={invalidateRevenueOpportunityStatusPresetsTableQuery}
    />
  );
};

export default RevenueOpportunityStatusPresetsTableV3;
